import React from 'react';
import PropTypes from 'prop-types';
import './styles.styl';

const ProgressBar = ({ paths, farthestPath, progressBarImage }) => {
  const progress = (paths.indexOf(farthestPath) + 1) / paths.length;

  return (
    <div className="progress-bar-wrapper">
      <div className="progress-bar">
        <span
          className="progress-bar__bar"
          style={{ transform: `scaleX(${progress})` }}
        />
      </div>
      {progressBarImage && (
        <img className="progress-bar__image" src={progressBarImage} alt="" />
      )}
    </div>
  );
};

ProgressBar.defaultProps = {
  farthestPath: null
};

ProgressBar.propTypes = {
  paths: PropTypes.array.isRequired,
  farthestPath: PropTypes.string
};

export default ProgressBar;



// WEBPACK FOOTER //
// ../core/src/components/ProgressBar/ProgressBar.js